import ByAlphabetContainer from 'components/ByAlphabet/ByAlphabetContainer'
import ByAlphabetPresentation from 'components/ByAlphabet/ByAlphabetPresentation'
import ByAlphabetData from 'components/ByAlphabet/ByAlphabetData'

export default {
  Container: ByAlphabetContainer,
  Presentation: ByAlphabetPresentation,
  Data: ByAlphabetData,
}
